import React, { useState } from 'react'
import FlexComponent from '../FlexComponent'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { RadioButton } from 'primereact/radiobutton'
import { ErrorMessage, Field } from 'formik'
import { InputTextarea } from 'primereact/inputtextarea'
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar'
import { Checkbox } from 'primereact/checkbox'
import './form.css'

function YourCredit({ values, errors, touched, handleBlur, handleChange }) {


    return (
        <div style={{ width: '100%', padding: '0.5rem 0 0 5.8%' }} id='YourCredit'>
            {/* <div style={{ background: '#08113A' }}>
                <p style={{ fontSize: '28px', fontWeight: 'bold', padding: '0.75rem', color: 'white' }}>How is your credit?</p>
            </div> */}

            <div style={{ textAlign: 'start' }}>
                <div >
                    <p style={{ fontSize: '28px', fontWeight: 'bold', padding: '0.75rem', fontFamily: "Barlow Semi Condensed" }}>How is your credit?</p>
                </div>
                <FlexComponent className='inputFlexContainer' justifyContent="start" alignItems='start'>
                    <div className='inputContainerDiv' style={{ width: '20%', margin: '0.5rem' }}>
                        {/* <label htmlFor="estimated_credit_score" style={{ fontWeight: 'bold', color: Boolean(touched.estimated_credit_score && errors.estimated_credit_score) ? 'red' : '' }}>Estimated Credit Score*</label> */}
                        <Field type="number" id="estimated_credit_score" placeholder="Credit Score*" className={Boolean((touched.estimated_credit_score && errors.estimated_credit_score)) && "fieldErrorShow"} name="estimated_credit_score" as={InputText} style={{ width: '100%' }} onBlur={handleBlur} />
                        {/* <ErrorMessage name="estimated_credit_score" component="div" className="error" style={{color:'red'}} /> */}
                    </div>

                    <div className='inputContainerDiv' style={{ width: '25%', margin: '0.5rem' }}>
                        {/* <label style={{ fontWeight: 'bold' }} htmlFor="date_of_birth" >Date Of Birth</label> */}
                        <Field
                            name="date_of_birth"
                        >{({ field, form }) => (
                            <Calendar
                                id={field.name}
                                value={field.value}
                                style={{ width: '100%' }}
                                onChange={(e) => form.setFieldValue(field.name, e.value)}
                                placeholder='Date Of Birth'
                            />
                        )
                            }</Field>
                    </div>
                    <div className='inputContainerDiv' style={{ width: '25%', margin: '0.5rem' }}>
                        {/* <label htmlFor="social_security_no" style={{ fontWeight: 'bold' }}>##</label>
                        <Field type="text" id="social_security_no" name="social_security_no" as={InputText} style={{ width: '100%' }} onBlur={handleBlur} placeholder="000-00-0000" /> */}
                        {/* <div className={`p-inputgroup flex-1 login-input-div ${touched.cell_phone_number && errors.cell_phone_number ? "fieldErrorShow" : ""}`}>
                            <span className="p-inputgroup-addon" style={{ background: 'white' }}>
                                ##
                            </span> */}
                        <Field type="text" id="social_security_no" name="social_security_no" as={InputText} style={{ width: '100%' }} onBlur={handleBlur} placeholder="SSN" />
                        {/* </div> */}
                    </div>

                </FlexComponent>


                {/* <div className='inputContainerDiv' style={{ width: '35%', textAlign: 'start', margin: '0.5rem' }}>
                    <Dropdown
                        id='status_in_country'
                        value={values.status_in_country}
                        options={[
                            { label: "Citizen / Green Card", value: "Citizen / Green Card" },
                            { label: "Work Authorization", value: "Work Authorization" },
                            { label: "ITIN", value: "ITIN" },
                        ]}
                        style={{ width: '100%' }}

                        onChange={(e) => {
                            // handleChange('status_in_country')(e.value)
                            handleChange({
                                target: {
                                    name: `status_in_country`,
                                    value: e.value
                                }
                            })
                        }}
                        showClear={values.status_in_country}
                        onBlur={handleBlur}
                        placeholder='Status In Country'
                    />
                </div> */}

            </div>

        </div >
    )
}

export default YourCredit